// Add DOM4 support, https://github.com/WebReflection/dom4
import 'dom4';
//bootstrap
import 'jquery';

//bootstrap
import 'bootstrap';

// Add Babel polyfill for ES2015, https://babeljs.io/docs/usage/polyfill/
import 'babel-polyfill';

//fontfaceobserver
import FontFaceObserver from 'fontfaceobserver';

//scroll bars
import SimpleBar from 'simplebar';

//match height  data-mh="my-group"
import matchHeight from 'jquery-match-height';

/**
 * Import all  components.
 */

import Navi from './components/navi/navi';
import JqeryFunction from './components/component/jqueryfunction';
import Slickslider from './components/slickslider/slickslider';
import Validator from './components/validator/validator';

export {
  Navi,
  JqeryFunction,
  Slickslider,
  Validator
}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/Js/index.js
 **/